export const BUSINESS_CLOSE_REASON = {
    bankrupt: {
        en: 'Bankruptcy',
        es: 'Bancarrota'
    },
    sales: {
        en: 'Insufficient Sales or customer interest',
        es: 'Ventas insuficientes o falta de interés de los clientes'
    },
    problems: {
        en: 'Other problems with the business or business strategy',
        es: 'Otros problemas con el negocio o la estrategia comercial'
    },
    sought_wage: {
        en: 'Preferred a wage job',
        es: 'Prefería un trabajo con sueldo'
    },
    health: {
        en: 'Illness or health reasons of business owner',
        es: 'Enfermedad o problemas de salud del dueño del negocio'
    },
    personal: {
        en: 'Needed to take care of family member / other household concerns made continuation of the business difficult',
        es: 'Necesitaba cuidar a un miembro de la familia / otras cuestiones del hogar hicieron difícil la continuación del negocio'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    na: {
        en: 'N/A',
        es: 'N/A'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
